const messages = {
  title: "Butikk",
  description: "Velkommen til premieshop. Her kan du løse inn Bridgestone Plus-poengene dine <br/> mot premier fra ulike kategorier. Produktutvalget <br/> oppdateres regelmessig. Vi ønsker deg lykke til med å browse.",
  sort: {
    asc: "Sorter etter: Laveste pris",
    desc: "Sorter etter: Høyeste pris",
  },
  productSearchBox: {
    from: "poeng fra",
    to: "poeng til",
  },
  noProducts: "Søkekriteriene ga ingen resultater",
  quantity: "Antall",
  search: "Søk",
  perPage: "Elementer per side",
  timeUnavailable: "For øyeblikket ikkje tilgjengelig",
  product: "Produkt",
  cart: {
    pointsPerUnit: "Poeng per enhet",
    pointsSum: "Sum poeng",
  },
  action: "Handling",
  pointsTotal: "Totalt",
  cartRemainPoints: "Atteståande poeng i handlekurv",
  shoppingCart: "Handlevogn",
  emptyCart: "Handlevognen er tom.",
  attributes: "Egenskaper",
  selectAddressP: "Vennlegst velg leveringsadressen din",
  orderDelivery: "Leveringsadresse",
  selectedProducts: "Valgte produkter",
  orderSummary: "Ordreoversikt",
  contactPerson: "Kontaktperson",
  selectedAddress: "Valgt adresse",
  order: {
    success: "Takk! Bestillingen din var vellykket. Du mottar en ordrebekreftelse i innboksen din om noen minutter.",
    description: "Her finner du en oversikt over bestillingene dine fra premieshop.",
    info: "Her finner du en oversikt over bestillingene dine fra premieshop.",
    date: "Bestillingsdato",
    number: "Ordre nr.",
    status: {
      created: "Opprettet",
      confirm_order: "Bekreft bestilling",
      ready_for_shipment: "Klar for forsendelse",
      rejected: "Avvist",
      processed: "Behandlet",
      shipped: "Sendt",
      returned: "Returnert",
      finished: "Fullført",
    },
    anyOrder: "Ingen bestillinger",
    products: "Produkter",
    quantity_short: "stk",
    itemRemoved: "kan ikkje leverast",
  },
  orders: "Bestillinger",
  notEnoughPoints: "Ikke nok poeng tilgjengelig.",
  statusText: "Status",
  outOfStock: "For øyeblikket ikkje på lager",
  productUnavailable: "Dette produktet er ikkje lenger tilgjengelig.",
  deletedProductsTitle: "Produkter ikkje lenger tilgjengelig",
  deletedProductsMessage: "Følgende produkt(er) er ikkje lenger tilgjengelige. Fjern dem fra handlevogna for å fortsette.",
  removeSelected: "Fjern valde",
  clearCart: "Tøm handlevogn",
  removeSelectedConfirm: "Fjerne dei valde produkta frå handlevogna?",
  clearCartConfirm: "Fjerne alle produkt frå handlevogna?",
  incompleteAddress: {
    firstName: "Legg til eit fornamn i leveringsadressa",
    lastName: "Legg til eit etternamn i leveringsadressa",
    company: "Legg til eit firmanamn i leveringsadressa",
    street: "Legg til gate og husnummer i leveringsadressa",
    postalCode: "Legg til postnummer i leveringsadressa",
    city: "Legg til stad i leveringsadressa",
    country: "Legg til land i leveringsadressa",
    phone: "Legg til eit telefonnummer i leveringsadressa",
  },
  placeOrder: "Bindende bestilling",
  toOrderDelivery: "Fortsett til leveringsadresse",
  toOrderSummary: "Til bestillingsoversikt",
  productImg: "Produktbilde",
  selectAddressBtn: "Velg adresse",
  perPgae: "Elementer per side",
  categories: {
    advertising: {
      title: "Reklamemateriell",
      desc: "Delta direkte her på plattformen og sikre <br/> 40 ekstra poeng for belønningsklubben.",
    },
    rewards: {
      title: "Eksklusive belønninger",
      desc: "Oppdag bonustilbudet i vårt opplæringssenter eller hos deg.",
    },
    tools: {
      title: "Verkstedverktøy",
      desc: "Bruk poengene dine på tredjepartsopplæring <br/> og reduser kostnadene.",
    },
    trainings: {
      title: "Opplæring og kurs",
      desc: "Oppdag bonustilbudet i vårt opplæringssenter eller hos deg.",
    },
    salesroom: {
      title: "Salgsrom",
      desc: "Gi salgsrommet et løft og tilby kundene et behagelig opphold.",
    },
    hunter: {
      title: "Hunter",
      desc: "Bytt poeng mot attraktivt verkstedsutstyr fra Hunter.",
    },
  },
  bestSold: "Bestselgere",
  seasonal: "Sesong",
  affordable: "Nesten i mål",
  forPoints: "for {points} poeng",
  reachedPoints: "Nødvendige poeng nådd",
  remainingPoints: "{points} poeng gjenstår",
  favoriteProducts: {
    description: "Her finner du produktene du har lagret.",
  },
  categoryPageDescriptionFallback: "Materiell til verkstedet eller andre kvalitetsprodukter med Bridgestone-logo for bedriften din",
  variant: "Valgbare varianter",
};
export default {
  messages,
};
